import { OptionSelect } from "../../../common/interfaces";

interface TypeProduction {
  label: {
    "pt-br": string;
    "es-es": string;
    "en-us": string;
  };
  value: string;
}

const typeProduction: TypeProduction[] = [
  {
    label: {
      "pt-br": "Extensivo",
      "en-us": "Extensive",
      "es-es": "Extensivo",
    },
    value: "Extensivo",
  },
  {
    label: {
      "pt-br": "Semi-Intensivo",
      "en-us": "Semi-Intensive",
      "es-es": "Semi-intensivo",
    },
    value: "Semi-Intensivo",
  },
  {
    label: {
      "pt-br": "Intensivo",
      "en-us": "Intensive",
      "es-es": "Intensivo",
    },
    value: "Intensivo",
  },
];

const companys: OptionSelect[] = [
  { label: "Itambé", value: "Itambé" },
  { label: "Nestlé", value: "Nestlé" },
  { label: "Outro", value: "Outro" },
];

export { companys, typeProduction };
